const Invoice = {

  /**
   * Instantiate invoice
   * @param {HTMLElement} node
   * @return {void}
   */
  create(node) {
    this.node = node;
    this.button = document.querySelector('.js-show-more-invoices');
    this.invoices = document.querySelectorAll('.js-invoice');

    this.toggleInvoices();
  },

  toggleInvoices() {
    this.invoices = Array.prototype.slice.call(this.invoices);

    this.invoices.forEach((element, index) => {
      if (index >= 5) {
        element.classList.add('d-none');
      }
    });

    if (this.button) {
      this.button.addEventListener('click', () => {
        this.button.classList.toggle('is-open');
        let isOpen = this.button.classList.contains('is-open');
        isOpen = !isOpen;

        if (isOpen) {
          this.button.innerHTML = 'Bekijk meer';
        } else {
          this.button.innerHTML = 'Bekijk minder';
        }

        this.invoices.forEach((element, index) => {
          if (index >= 5) {
            element.classList.toggle('d-none');
          }
        });
      });
    }
  },
};

export default Invoice;
